var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagePlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18.5V12.5C6.5 10.29 8.29 8.5 10.5 8.5H38.5C40.71 8.5 42.5 10.29 42.5 12.5V36.5C42.5 38.71 40.71 40.5 38.5 40.5H26.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 40.5L17.998 39.24C17.744 38.602 17.35 38.028 16.846 37.562C15.992 36.77 14.87 36.332 13.708 36.332H9.292C8.128 36.332 7.008 36.772 6.154 37.562C5.65 38.028 5.256 38.602 5.002 39.24L4.5 40.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9745 25.526C15.3405 26.892 15.3405 29.108 13.9745 30.476C12.6085 31.842 10.3925 31.842 9.0245 30.476C7.6585 29.11 7.6585 26.894 9.0245 25.526C10.3925 24.158 12.6085 24.158 13.9745 25.526Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30.5V18.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 30.5V23.86",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30.5V19.6",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePlant);
export default __webpack_public_path__ + "static/media/managePlant.475d4b7f5df38d29b07beeb449b880a6.svg";
export { ForwardRef as ReactComponent };